/**
 * @generated SignedSource<<c30f06e5e17ceb52b6a38f3b588ce8b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionOrderId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionOrderCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateSubscriptionOrderTPayload",
        "kind": "LinkedField",
        "name": "createSubscriptionOrderT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionOrderT",
            "kind": "LinkedField",
            "name": "subscriptionOrderT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionOrderCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateSubscriptionOrderTPayload",
        "kind": "LinkedField",
        "name": "createSubscriptionOrderT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionOrderT",
            "kind": "LinkedField",
            "name": "subscriptionOrderT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8e636d55e83ad22be82c55bfd3c78fc3",
    "id": null,
    "metadata": {},
    "name": "SubscriptionOrderCreateMutation",
    "operationKind": "mutation",
    "text": "mutation SubscriptionOrderCreateMutation(\n  $input: CreateSubscriptionOrderTInput!\n) {\n  createSubscriptionOrderT(input: $input) {\n    subscriptionOrderT {\n      subscriptionOrderId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "8ddb5f17192bff95cc45967a469a3e54";

module.exports = node;
